import { afterNextRender, Component, ElementRef, EventEmitter, Input, Output, Renderer2, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
// import { DateAdapter } from '@angular/material/core';
import { DateRange, MatCalendar, MatCalendarView, MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DatePipe, NgIf } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MainService } from '../shared/services/main.service';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { from } from 'rxjs';
import { concatMap, map, filter, take, defaultIfEmpty } from 'rxjs/operators';
import { DateAdapter } from '@angular/material/core';
import { CustomDateAdapter } from './custom-date-adapter';

@Component({
  selector: 'app-datepicker-inline-calendar',
  standalone: true,
  imports: [
    MatCardModule,
    MatDatepickerModule,
    NgIf,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    TranslateModule
  ],
  templateUrl: './datepicker-inline-calendar.component.html',
  styleUrl: './datepicker-inline-calendar.component.scss',
  encapsulation: ViewEncapsulation.ShadowDom,
  providers: [{ provide: DateAdapter, useClass: CustomDateAdapter }],

})
export class DatepickerInlineCalendarComponent {
  @Input() isIntegration: boolean = false;
  @Input() external_channel: any;
  @Input() channelactivitycode: any;
  @Input() productid: any;
  @Input() producttype: any;
  @Input() queryParams: any;
  @Input() dateParams: any;
  @Input() connector: any;
  @Input() pickup: any = null;
  @Input() pickupArea: any = null;
  @Input() maxSearchMonths: number = 12;
  @Input() pricing: any = null;
  @Input() lang: any;
  selected: any | null;
  @Input() selectedRangeValue: any | undefined;
  @Output() selectedRangeValueChange = new EventEmitter<any>();
  @Output() advanceFirstStep = new EventEmitter<boolean>();
  @Output() pickupSelected = new EventEmitter<any>();
  @Output() noPickupAvailable = new EventEmitter<any>();
  @ViewChild('myCalendar') myCalendar!: MatCalendar<Date>;

  // Vincular evento recargar precios en el calendario, cada vez que se vuelve a crear por el ngif
  @ViewChild('myCalendar') set calendarSetter(cal: MatCalendar<Date> | undefined) {
    if (!cal) return;
    this.myCalendar = cal;
    // console.log("calendar attached");
    cal.stateChanges.subscribe(() => {
      requestAnimationFrame(() => {
        this.renderPricesOnCalendar();
      });
    });
  }

  private _refreshToken = 0;
  @Input() set refreshToken(v: number) {
    if (v !== this._refreshToken) {
      this._refreshToken = v;
      if (this.channelactivitycode && this._refreshToken > 1) {
        this.searchStartDate = new Date();
        this.myGetActivityAvailabilities();
      }
    }
  }

  showCalendar = false;
  availableDays = <any>[];
  // availableDaysAux = <any>[];
  shadowRoot: any;
  // Guard to prevent concurrent / duplicated availability requests
  private availRequestInFlight: boolean = false;

  searchStartDate = new Date();
  eventListenersAdded = false;
  manuallyChangedCalendar = false;
  loadedMonths = new Set<string>();
  availableDaysMap = new Map<string, any>();

  constructor(private datePipe: DatePipe, private elementRef: ElementRef, private mainService: MainService, private renderer: Renderer2, public translateService: TranslateService, private dateAdapter: DateAdapter<Date>) {
    const originalAddEventListener = EventTarget.prototype.addEventListener;

    // language will be initialized in ngOnChanges when `lang` input is available

    EventTarget.prototype.addEventListener = function (
      type: string,
      listener: any,
      options?: boolean | AddEventListenerOptions
    ) {
      const target = this as HTMLElement;

      // Si es touchmove y se está registrando sobre .mat-calendar-body
      if (
        type === 'touchmove' &&
        target?.classList?.contains('mat-calendar-body')
      ) {
        // Fuerza el listener como pasivo
        const forcedOptions: AddEventListenerOptions =
          typeof options === 'boolean'
            ? { passive: true, capture: options }
            : { ...options, passive: true };

        return originalAddEventListener.call(this, type, listener, forcedOptions);
      }

      return originalAddEventListener.call(this, type, listener, options);
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log(changes);

    // if ('pricing' in changes) {
    //   setTimeout(() => this.renderPricesOnCalendar(), 500);
    // }

    if ('lang' in changes) {
      const locale = this.mapLangToLocale(this.lang);
      // this.dateAdapter.setLocale(locale);
    }
    if (changes['lang'] && changes['lang'].currentValue != undefined) {
      const newLang = changes['lang'].currentValue;
      this.translateService.setDefaultLang(newLang);
      const locale = this.mapLangToLocale(this.lang);
      this.dateAdapter.setLocale(locale);
      // setTimeout(() => this.renderPricesOnCalendar(), 500);
      // use returns an observable that emits when translations are loaded
      this.translateService.use(newLang).subscribe({
        next: () => {
          // translations loaded
        },
        error: () => {
          // ignore load errors here
        }
      });
    }

    if (changes['channelactivitycode'] && changes['channelactivitycode'].currentValue != undefined) {
      this.myGetActivityAvailabilities();
    }
  }

  ngOnInit() {
    this.dateParams = {
      "startDate": "2025-02-07",
      "endDate": "2025-02-09"
    } // Variable
    this.shadowRoot = this.elementRef.nativeElement.shadowRoot;
  }

  private mapLangToLocale(lang: any): string {
    const l = (lang ?? '').toString().toLowerCase();
    // ajustar si hay mas idiomas
    if (l.startsWith('en')) return 'en-GB';
    if (l.startsWith('de')) return 'de-DE';
    if (l.startsWith('fr')) return 'fr-FR';
    if (l.startsWith('pt')) return 'pt-PT';
    if (l.startsWith('it')) return 'it-IT';
    // 'ca' -> catalán (Spain)
    if (l.startsWith('ca')) return 'ca-ES';
    return 'es-ES';
  }

  selectedChange(m: any) {
    if (!this.selectedRangeValue?.start || this.selectedRangeValue?.end) {
      this.selectedRangeValue = new DateRange<Date>(m, null);
    } else {
      const start = this.selectedRangeValue.start;
      const end = m;
      if (end < start) {
        this.selectedRangeValue = new DateRange<Date>(end, start);
      } else {
        this.selectedRangeValue = new DateRange<Date>(start, end);
      }
    }
    // Close the calendar on range select
    if (this.selectedRangeValue.start && this.selectedRangeValue.end) {
      this.selectedRangeValueChange.emit({ selectedValue: this.selectedRangeValue, availableDays: this.availableDays });
    }

    if (this.selectedRangeValue.start && this.producttype == 'Activity') {
      this.selectedRangeValue.end = this.selectedRangeValue.start;
      this.selectedRangeValueChange.emit({ selectedValue: this.selectedRangeValue, availableDays: this.availableDays });
    }
  }

  formatedDate(date: any) {
    let auxDate = new Date(date)
    return this.datePipe.transform(auxDate, 'dd/MM');
  }

  getMonthKey(date: Date): string {
    return `${date.getFullYear()}-${date.getMonth()}`;
  }

  myGetActivityAvailabilities(date?: any) {
    // Prevent duplicate in-flight calls
    if (this.availRequestInFlight) {
      console.debug('myGetActivityAvailabilities: request already in flight — skipping duplicate call');
      return;
    }

    this.showCalendar = false;

    let dateStart = new Date();
    let firstDayOfMonth = new Date(dateStart.getFullYear(), dateStart.getMonth(), 1);
    let dateThreeMonthsAfter = new Date(dateStart.getFullYear(), dateStart.getMonth(), 1);
    let initialLoad = false

    if (!date) {

      if (this.external_channel == "musement_pull") {

        // If no date provided, call the backend without `toStr` (empty) so it returns
        // the first available date regardless of month. This avoids iterating month-by-month.
        const fromStrOpen = firstDayOfMonth.toLocaleDateString('en-US');
        const toStrOpen = null; // backend interprets missing/empty toStr as open-ended

        // mark in-flight now
        this.availRequestInFlight = true;

        if (this.pickupArea) {
          from(this.pickupArea ?? [])
            .pipe(
              concatMap((pickup: any) =>
                this.mainService
                  .getActivityAvailabilities(this.connector, this.external_channel, 'activity_availabilities',
                    fromStrOpen, toStrOpen, this.channelactivitycode, pickup.pickup)
                  .pipe(map(result => ({ pickup, result })))
              ),
              filter(({ result }) => Array.isArray(result) && result.length > 0),
              take(1),                 // primer pickup con datos
              defaultIfEmpty(null)     // si ninguno tiene dispo
            )
            .subscribe((hit: any) => {
              try {
                if (hit) {
                  // update searchStartDate to the month containing the first available day
                  const firstRaw = Array.isArray(hit.result) && hit.result.length > 0 ? (hit.result[0].date ?? hit.result[0]) : null;
                  if (firstRaw) {
                    const d = new Date(firstRaw);
                    this.searchStartDate = new Date(d.getFullYear(), d.getMonth(), 1);
                  }
                  // Keep the pickup that had availability for subsequent month searches
                  this.pickup = hit.pickup.pickup;
                  this.pickupArea = null;
                  this.noPickupAvailable.emit({ noAvailability: false, pickup: hit.pickup });
                  this.processAvailabilities(hit.result, hit.pickup.pickup);
                } else {
                  // invalid_pickup se usa cuando es la primera peticion y no hay dispo, en caso de que no sea la primera peticion
                  // no se envia porque no queremos ocultar el calendario en ese caso.
                  this.noPickupAvailable.emit({ noAvailability: true, invalid_pickup: true });
                  this.showCalendar = true;
                  setTimeout(() => {
                    this.setCalendarMonth();
                    const nextButton = this.shadowRoot.querySelector('.mat-calendar-next-button');
                    nextButton?.addEventListener('click', this.onNextClick.bind(this));
                    const prevButton = this.shadowRoot.querySelector('.mat-calendar-previous-button');
                    prevButton?.addEventListener('click', this.onPrevClick.bind(this));
                  }, 0);
                }
              } finally {
                this.availRequestInFlight = false;
              }
            }, (err) => {
              console.error('myGetActivityAvailabilities open-ended error', err);
              this.availRequestInFlight = false;
            });
        } else {
          this.mainService.getActivityAvailabilities(this.connector, this.external_channel, 'activities_calendar', fromStrOpen, toStrOpen, this.channelactivitycode, this.pickup).subscribe(result => {
            try {
              if (result.length > 0) {
                this.noPickupAvailable.emit({ noAvailability: false, pickup: this.pickup });
                this.processAvailabilities(result, this.pickup);
              } else {
                this.noPickupAvailable.emit({ noAvailability: true });
                this.showCalendar = true;
                setTimeout(() => {
                  this.setCalendarMonth();
                  const nextButton = this.shadowRoot.querySelector('.mat-calendar-next-button');
                  nextButton?.addEventListener('click', this.onNextClick.bind(this));
                  const prevButton = this.shadowRoot.querySelector('.mat-calendar-previous-button');
                  prevButton?.addEventListener('click', this.onPrevClick.bind(this));
                }, 0);
              }
            } finally {
              this.availRequestInFlight = false;
            }
          }, (err) => {
            console.error('myGetActivityAvailabilities open-ended error', err);
            this.availRequestInFlight = false;
          });
        }
        return;
      } else {
        dateThreeMonthsAfter.setMonth(dateThreeMonthsAfter.getMonth() + 1);
        dateThreeMonthsAfter.setDate(dateThreeMonthsAfter.getDate() - 1);
        initialLoad = true
      }

    } else {
      firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);

      dateThreeMonthsAfter = new Date(date.getFullYear(), date.getMonth(), 1);

      dateThreeMonthsAfter.setMonth(date.getMonth() + 1);
      dateThreeMonthsAfter.setDate(dateThreeMonthsAfter.getDate() - 1);
    }


    const fromStr = firstDayOfMonth.toLocaleDateString('en-US');

    // al cargar el calendario, llamar a toda la availability disponible a partir de la fecha de hoy 
    // al llegar al final de la dispo cargada, llama de mes en mes
    let toStr = "";
    if (
      this.external_channel !== "musement_pull" &&
      (!initialLoad || this.external_channel === "globick_pull")
    ) {
      toStr = dateThreeMonthsAfter.toLocaleDateString("en-US");
    }

    // mark in-flight now that we're about to start network calls for this month-range
    this.availRequestInFlight = true;

    if (this.pickupArea) {
      from(this.pickupArea ?? [])
        .pipe(
          concatMap((pickup: any) =>
            this.mainService
              .getActivityAvailabilities(this.connector, this.external_channel, 'activity_availabilities',
                fromStr, toStr, this.channelactivitycode, pickup.pickup)
              .pipe(map(result => ({ pickup, result })))
          ),
          filter(({ result }) => Array.isArray(result) && result.length > 0),
          take(1),                 // primer pickup con datos
          defaultIfEmpty(null)     // si ninguno tiene dispo
        )
        .subscribe(hit => {
          try {
            if (hit) {
              // update searchStartDate to the month containing the first available day
              const firstRaw = Array.isArray(hit.result) && hit.result.length > 0 ? (hit.result[0].date ?? hit.result[0]) : null;
              if (firstRaw) {
                const d = new Date(firstRaw);
                this.searchStartDate = new Date(d.getFullYear(), d.getMonth(), 1);
              }
              // Keep the pickup that had availability for subsequent month searches
              this.pickup = hit.pickup.pickup;
              this.pickupArea = null;
              this.noPickupAvailable.emit({ noAvailability: false, pickup: hit.pickup });
              this.processAvailabilities(hit.result, hit.pickup.pickup);
            } else {
              // fallback si ninguno tuvo resultados
              this.noPickupAvailable.emit({ noAvailability: true });
              this.showCalendar = true;
              setTimeout(() => {
                this.setCalendarMonth();
                const nextButton = this.shadowRoot.querySelector('.mat-calendar-next-button');
                nextButton?.addEventListener('click', this.onNextClick.bind(this));
                const prevButton = this.shadowRoot.querySelector('.mat-calendar-previous-button');
                prevButton?.addEventListener('click', this.onPrevClick.bind(this));
              }, 0);
            }
          } finally {
            this.availRequestInFlight = false;
          }
        }, (err) => {
          console.error('myGetActivityAvailabilities error', err);
          this.availRequestInFlight = false;
        });
    } else {
      this.mainService.getActivityAvailabilities(this.connector, this.external_channel, 'activities_calendar', fromStr, toStr, this.channelactivitycode, this.pickup).subscribe(result => {
        try {
          if (result.length > 0) {
            const firstRaw = result[0] ? (result[0].date ?? result[0]) : null;
            if (firstRaw) {
              const d = new Date(firstRaw);
              this.searchStartDate = new Date(d.getFullYear(), d.getMonth(), 1);
              // console.log(this.searchStartDate);

            }
            this.noPickupAvailable.emit({ noAvailability: false, pickup: this.pickup });
            this.processAvailabilities(result, this.pickup);
          } else {
            this.noPickupAvailable.emit({ noAvailability: true });
            this.showCalendar = true;

            setTimeout(() => {
              this.setCalendarMonth();
              // repintar precios existentes
              const nextButton = this.shadowRoot.querySelector('.mat-calendar-next-button');
              nextButton?.addEventListener('click', this.onNextClick.bind(this));
              const prevButton = this.shadowRoot.querySelector('.mat-calendar-previous-button');
              prevButton?.addEventListener('click', this.onPrevClick.bind(this));
            }, 0);
          }
        } finally {
          this.availRequestInFlight = false;
        }
      }, (err) => {
        console.error('myGetActivityAvailabilities error', err);
        this.availRequestInFlight = false;
      });
    }
  }

  // Saca tu lógica actual de pintado a una función reutilizable:
  private processAvailabilities(result: any[], pickup: any) {
    this.pickupSelected.emit(pickup);

    this.loadedMonths.clear()

    result.forEach((day: any, index: number) => {

      let rawDate = day.date ? day.date : day;
      const d = new Date(rawDate);
      // save loaded month
      this.loadedMonths.add(this.getMonthKey(d));

      let dayObj = day;
      if (this.connector !== 'hub2b') {
        dayObj = {
          date: day.date ? day.date : day,
          productId: this.channelactivitycode,
          externalSupplierCode: this.channelactivitycode,
          pickup: pickup,
          hubId: this.productid
        };
      }

      // save available day formated
      const iso = (dayObj.date ?? '').split("T")[0];

      // if (!this.availableDays.some((d: any) => (d.date ?? '').split("T")[0] === iso)) {
      this.availableDays.push(dayObj);
      // }

      // this.availableDaysMap.set(iso, dayObj);


      if (index === result.length - 1) {
        // setTimeout(() => {
        this.showCalendar = true;
        setTimeout(() => {
          this.setCalendarMonth();
          this.renderPricesOnCalendar();
          const nextButton = this.shadowRoot.querySelector('.mat-calendar-next-button');
          nextButton?.addEventListener('click', this.onNextClick.bind(this));
          const prevButton = this.shadowRoot.querySelector('.mat-calendar-previous-button');
          prevButton?.addEventListener('click', this.onPrevClick.bind(this));
        }, 250);
        // }, 500);
      }
    });

    // tu lógica de rangos si aplica
    if (this.dateParams.startDate === this.dateParams.endDate && this.dateParams.startDate !== undefined) {
      setTimeout(() => {
        this.selectedRangeValue = new DateRange<Date>(
          new Date(this.dateParams.startDate),
          new Date(this.queryParams.endDate)
        );
        this.selectedRangeValue.end = this.selectedRangeValue.start;
        this.selectedRangeValueChange.emit({ selectedValue: this.selectedRangeValue, availableDays: this.availableDays });
      }, 0);
    }
    // habilitar botones
    this.shadowRoot.querySelector('.mat-calendar-next-button')?.removeAttribute('disabled');
    this.shadowRoot.querySelector('.mat-calendar-previous-button')?.removeAttribute('disabled');
  }

  // pintar precios en el calendario
  renderPricesOnCalendar() {

    this.shadowRoot.querySelectorAll('.price-text').forEach((el: any) => el.remove());

    if (!this.availableDays?.length) return;

    const minPrices: Record<string, number> = {};

    this.availableDays.forEach((activity: any) => {
      const isoDate = (activity.date ?? '').split("T")[0];
      //         // price: (this.pricing && this.pricing.markup && activity.activitySchedule.activitySeason.activityFee.modality.cost) ? (this.rounded(1 * (this.pricing.markup ? ((activity.activitySchedule.activitySeason.activityFee.modality.cost / (1 - this.pricing.markup / 100) / (1 - this.pricing.percentage / 100)) >= activity.activitySchedule.activitySeason.activityFee.modality.price ? (activity.activitySchedule.activitySeason.activityFee.modality.cost / (1 - this.pricing.markup / 100) / (1 - this.pricing.percentage / 100)) : activity.activitySchedule.activitySeason.activityFee.modality.price) : activity.activitySchedule.activitySeason.activityFee.modality.price))) : activity.activitySchedule.activitySeason.activityFee.modality.price
      const price = this.pricing && this.pricing.markup && activity.cost ? (this.rounded(1 * (this.pricing.markup ? ((activity.cost / (1 - this.pricing.markup / 100) / (1 - this.pricing.percentage / 100)) >= activity.price ? (activity.cost / (1 - this.pricing.markup / 100) / (1 - this.pricing.percentage / 100)) : activity.price) : activity.price))) : activity.price
      // const price = Math.round(parseFloat(activity?.price?.toString() ?? "0"));

      // si no ha precio no pintamos
      if (!price || price <= 0) return;

      minPrices[isoDate] =
        minPrices[isoDate] !== undefined
          ? Math.min(minPrices[isoDate], price)
          : price;

    });

    Object.entries(minPrices).forEach(([isoDate, price]) => {
      const label = this.formatDate(new Date(isoDate));
      const cells: any = this.shadowRoot.querySelectorAll('[aria-label="' + label + '"]');

      if (!cells?.length) return;

      const priceText = document.createElement("span");
      priceText.classList.add("price-text");
      priceText.textContent = this.getLowestPrice([{ date: isoDate, price }]);
      // evita problema al hacer click a la fecha, que no funcionaba al primer clic
      priceText.style.pointerEvents = "none";

      cells[0].querySelector('span').style.alignItems = "start";
      cells[0].appendChild(priceText);

    });

  }


  onNextClick() {
    let nextButton = this.shadowRoot.querySelector('.mat-calendar-next-button')
    nextButton.setAttribute("disabled", "true");

    const nextDate = new Date(this.searchStartDate);
    nextDate.setMonth(nextDate.getMonth() + 1);

    const key = this.getMonthKey(nextDate);

    // if loaded month -> no call
    if (this.loadedMonths.has(key)) {
      this.searchStartDate = nextDate;
      nextButton.removeAttribute("disabled");
      this.noPickupAvailable.emit({ noAvailability: false });

      // repintar precios inmediatamente
      setTimeout(() => this.renderPricesOnCalendar(), 0);

      return;
    }

    this.searchStartDate.setMonth(this.searchStartDate.getMonth() + 1)

    this.myGetActivityAvailabilities(this.searchStartDate);
  }

  onPrevClick() {

    const prevButton = this.shadowRoot.querySelector('.mat-calendar-previous-button');

    const today = new Date();
    const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);

    const prevDate = new Date(this.searchStartDate);
    prevDate.setMonth(prevDate.getMonth() - 1);
    const prevMonthStart = new Date(prevDate.getFullYear(), prevDate.getMonth(), 1);

    // si intenta ir a mes anterior al actual → forzar quedarse
    if (prevMonthStart < currentMonthStart) {

      // devolver el calendario al mes actual
      this.myCalendar.activeDate = new Date(currentMonthStart);

      // repintar
      setTimeout(() => this.setCalendarMonth(), 0);
      setTimeout(() => this.renderPricesOnCalendar(), 0);

      return;
    }

    prevButton?.setAttribute("disabled", "true");

    const key = this.getMonthKey(prevDate);

    if (this.loadedMonths.has(key)) {
      this.searchStartDate = prevDate;
      prevButton?.removeAttribute("disabled");
      this.noPickupAvailable.emit({ noAvailability: false });

      setTimeout(() => this.renderPricesOnCalendar(), 0);
      return;
    }

    this.searchStartDate = prevDate;
    this.myGetActivityAvailabilities(this.searchStartDate);
  }



  // Define dateFilter
  // dateFilter = (date: Date | null): boolean => {
  //   if (this.isIntegration) {
  //     return true
  //   }

  //   // If no available days, return true to allow all dates
  //   if (this.availableDays.length === 0) {
  //     return false;
  //   }

  //   const formatToNearestInteger = (priceStr: string): number => {
  //     return Math.round(parseFloat(priceStr));
  //   };

  //   // Recogemos los precios mas grandes de cada tipo de cliente para recoger todos los precios de adulto 
  //   // y entre todos los precios de adulto comparamos entre todas las modalidades de cada día para sacar 
  //   // el precio de adulto más barato de cada día:
  //   setTimeout(() => {
  //     let currentDate: any = this.shadowRoot.querySelectorAll('[aria-label="' + this.formatDate(date) + '"]');

  //     if (this.availableDays[0] && this.availableDays[0].date && !this.availableDays[0].productId) {
  //       const pricesByDate: { date: string; price: number }[] = this.availableDays.map((activity: any) => ({
  //         date: activity.date,
  //         // price: (this.pricing && this.pricing.markup && activity.activitySchedule.activitySeason.activityFee.modality.cost) ? (this.rounded(1 * (this.pricing.markup ? ((activity.activitySchedule.activitySeason.activityFee.modality.cost / (1 - this.pricing.markup / 100) / (1 - this.pricing.percentage / 100)) >= activity.activitySchedule.activitySeason.activityFee.modality.price ? (activity.activitySchedule.activitySeason.activityFee.modality.cost / (1 - this.pricing.markup / 100) / (1 - this.pricing.percentage / 100)) : activity.activitySchedule.activitySeason.activityFee.modality.price) : activity.activitySchedule.activitySeason.activityFee.modality.price))) : activity.activitySchedule.activitySeason.activityFee.modality.price
  //         price: activity.price
  //       }));

  //       const minPrices: Record<string, number> = pricesByDate.reduce((acc, { date, price }) => {
  //         acc[date] = acc[date] ? Math.min(acc[date], formatToNearestInteger(price.toString())) : formatToNearestInteger(price.toString());
  //         return acc;
  //       }, {} as Record<string, number>);

  //       let minPricesPerDay = Object.entries(minPrices).map(([date, price]) => ({ date, price }));

  //       const priceText = document.createElement("span");
  //       priceText.classList.add("price-text");
  //       currentDate[0].querySelector('span').style.alignItems = "start";
  //       priceText.textContent = this.getLowestPrice(
  //         minPricesPerDay.filter((obj: any) => obj.date.split("T")[0] === this.formatDateToISO(new Date(date!)).split("T")[0])
  //       );

  //       currentDate[0]?.appendChild(priceText);
  //       // Añadir color blanco al price text del dia seleccionado cuando 
  //       // this.selectedRangeValue tiene valor (venimos desde el resumen de compra)
  //       if (this.selectedRangeValue && this.selectedRangeValue.getTime() === date?.getTime()) {
  //         priceText.style.color = "white";
  //       }
  //     }
  //   }, 0);

  //   let returnVariable = false;
  //   const now = new Date();

  //   // inicio de hoy (para comparar solo fecha)
  //   const todayStart = new Date();
  //   todayStart.setHours(0, 0, 0, 0);

  //   this.availableDays.forEach((day: any) => {

  //     if (!day?.date) return;

  //     const dayDate = new Date(day.date);

  //     // mismo día seleccionado 
  //     const sameDay =
  //       dayDate.toLocaleDateString("en-US", { timeZone: 'Europe/Madrid' }) ===
  //       date?.toLocaleDateString("en-US", { timeZone: 'Europe/Madrid' });

  //     if (!sameDay) return;

  //     // bloquear días pasados 
  //     const checkDay = new Date(day.date);
  //     checkDay.setHours(0, 0, 0, 0);

  //     if (checkDay < todayStart) {
  //       returnVariable = false;
  //       return;
  //     }

  //     // si ya aprobado antes
  //     if (this.availableDaysAux.includes(day.date)) {
  //       returnVariable = true;
  //       return;
  //     }

  //     // si NO tiene schedule -> permitir directamente
  //     if (!day.activitySchedule) {
  //       this.availableDaysAux.push(day.date);
  //       returnVariable = true;
  //       return;
  //     }

  //     // lógica antigua SOLO si existe schedule
  //     const schedule = day.activitySchedule;
  //     const fee = schedule?.activitySeason?.activityFee;
  //     const modality = fee?.modality;
  //     const activity = fee?.activity;

  //     const releaseHour = parseInt(activity?.releaseHour ?? 0, 10);

  //     const startOrEndTime = modality?.hasFlexibleHorary
  //       ? schedule?.endTime
  //       : schedule?.startTime;

  //     // si por lo que sea falta hora → permitir
  //     if (!startOrEndTime) {
  //       this.availableDaysAux.push(day.date);
  //       returnVariable = true;
  //       return;
  //     }

  //     const scheduleDateTime = new Date(
  //       this.addHoursToDatetime(day.date, startOrEndTime)
  //     );

  //     const minAllowedTime = new Date(now.getTime() + releaseHour * 3600000);

  //     if (scheduleDateTime >= minAllowedTime) {
  //       this.availableDaysAux.push(day.date);
  //       returnVariable = true;
  //     }

  //   });

  //   return returnVariable;

  // }

  // esta funcion debe ser lo más ligera posible, se ejecuta por cada fecha en el calendario
  dateFilter = (date: Date | null): boolean => {

    if (this.isIntegration) return true;
    if (!date) return false;

    // bloquear días anteriores a hoy
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const check = new Date(date);
    check.setHours(0, 0, 0, 0);

    if (check < today) return false;

    const iso = this.formatDateToISO(date).split("T")[0];

    return this.availableDays.some((d: any) => (d.date ?? '').split("T")[0] === iso);
  };


  rounded(price: any) {
    if (this.pricing.markup) {
      switch (this.pricing.roundedPrice.toLowerCase()) {
        case "up":
          return Math.ceil(price);
        case "down":
          return Math.floor(price);
        default:
          return parseFloat(price.toFixed(2));
      }
    } else {
      return price
    }
  }

  addHoursToDatetime(dateString: string, hourString: string) {
    const date = new Date(dateString);

    const [hours, minutes] = hourString.split(":").map(Number);

    const dateWithTime = new Date(date);
    dateWithTime.setHours(date.getHours() + hours);
    dateWithTime.setMinutes(date.getMinutes() + minutes);

    return dateWithTime
  }

  // Helper function to check if two dates represent the same day
  isSameDay(date1: Date | null, date2: Date): boolean {
    return (date1 && date1.getDate() === date2.getDate() && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear()) as any;
  }

  formatDate(date: any) {
    const d = new Date(date);
    return d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
  }

  getLowestPrice(pricesArray: any) {
    if (pricesArray.length === 0) return ''; // Handle empty array case
    return pricesArray.reduce((min: any, obj: any) => obj.activitySchedule.activityPrices[0].price < min.activitySchedule.activityPrices[0].price ? obj : min).price + '€';
  }

  formatDateToISO(date: any) {
    const d = new Date(date);

    // Obtener los componentes de la fecha
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // Mes comienza desde 0
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');

    // Ajustar la zona horaria manualmente a +01:00
    const timezoneOffset = '+01:00';

    return `${year}-${month}-${day}T${hours}:${minutes}:00${timezoneOffset}`;
  }

  // setCalendarMonth() {
  //   if (this.myCalendar && this.availableDaysMap.size > 0) {
  //     const today = new Date();

  //     const madridTZ = 'Europe/Madrid';

  //     const formatOptions: Intl.DateTimeFormatOptions = {
  //       timeZone: madridTZ,
  //       year: 'numeric',
  //       month: 'numeric',
  //       day: 'numeric'
  //     };
  //     const formatter = new Intl.DateTimeFormat('en-GB', formatOptions);
  //     const firstKey = this.availableDaysMap.keys().next().value;
  //     if (!firstKey) return;

  //     const [day, month, year] = formatter.formatToParts(new Date(firstKey))
  //       .reduce((acc: any, part: any) => {
  //         if (part.type === 'day') acc[0] = parseInt(part.value);
  //         if (part.type === 'month') acc[1] = parseInt(part.value);
  //         if (part.type === 'year') acc[2] = parseInt(part.value);
  //         return acc;
  //       }, []);

  //     // Creamos la fecha en horario de Madrid
  //     const firstAvailabilityDay = new Date(year, month - 1, day);

  //     // diff en meses incluyendo año
  //     const monthDifference =
  //       (firstAvailabilityDay.getFullYear() - today.getFullYear()) * 12 +
  //       (firstAvailabilityDay.getMonth() - today.getMonth());

  //     // mueve el calendario esa cantidad de meses
  //     const newDate = new Date(this.myCalendar.activeDate);
  //     newDate.setDate(1); // evita saltos por días 29–31
  //     newDate.setMonth(newDate.getMonth() + monthDifference);


  //     this.myCalendar.activeDate = newDate;
  //     this.manuallyChangedCalendar = true;

  //   } else if (this.myCalendar && this.searchStartDate) {
  //     this.myCalendar.activeDate = this.searchStartDate;
  //   }
  // }

  setCalendarMonth() {

    if (!this.myCalendar) return;

    // siempre priorizar el mes que quieres mostrar
    if (this.searchStartDate) {

      const newDate = new Date(this.searchStartDate);
      newDate.setDate(1);

      this.myCalendar.activeDate = newDate;
      this.manuallyChangedCalendar = true;
      return;
    }

  }
}
